import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { get } from 'lodash';
import { TableBody, TableRow, TableRowColumn } from '@unite-us/app-components';
import { browserHistory } from 'src/common/utils/browserHistory';
import { getAssistanceRequestPathname } from '../../pages/facesheet/_id/forms/assistanceRequests/getAssistanceRequestPathname';

const AssistanceRequestRow = ({ assistanceRequest }) => (
  <TableBody>
    <TableRow
      key={`table-row-ar-${assistanceRequest?.id}`}
      clickable
      hoverable={false}
      onCellClick={() => browserHistory.push({
          pathname: getAssistanceRequestPathname(assistanceRequest),
          state: { prevLocation: browserHistory.getCurrentLocation().pathname },
        })}
      style={{ borderBottom: '1px solid #E5E5E5' }}
    >
      <TableRowColumn>
        Assistance Request
      </TableRowColumn>
      <TableRowColumn>
        Client
      </TableRowColumn>
      <TableRowColumn>
        {assistanceRequest?.provider?.name}
      </TableRowColumn>
      <TableRowColumn>
        {moment(get(assistanceRequest, 'created_at') * 1000).format('MMMM DD, YYYY')}
      </TableRowColumn>
    </TableRow>
  </TableBody>
);

AssistanceRequestRow.propTypes = {
  assistanceRequest: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    provider: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
};

AssistanceRequestRow.defaultProps = {
  assistanceRequest: null,
};

export default AssistanceRequestRow;
